import _ from 'lodash';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CREATE_JOURNEY_CAMPAIGN_GROUP,
  createJourneyCampaignGroup,
} from 'omega-rtc/actions/ucd';
import { snackBar } from 'omega-rtc/components/custom/SnackBar';
import { UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { UCDCreateJourneyCampaign } from 'omega-rtc/views/ucd/UCDCreateJourneyCampaign';
import type { CreateJourneyCampaignRequest } from 'omega-rtc/views/ucd/UCDCreateJourneyCampaign';
import { useJourneyCampaignGroupEnabled } from 'omega-rtc/utils/portal-config';
import { RTC_NAMESPACE } from 'namespace';
import NotFoundPage from 'views/not-found/NotFoundPage';

const CreateJourneyCampaignGroup = (props: any) => {
  const dispatch = useDispatch();
  const enabled = useJourneyCampaignGroupEnabled();
  const createRequest = useSelector((state: any) => _.get(
    state.requests,
    getRequestStateKey(CREATE_JOURNEY_CAMPAIGN_GROUP),
    {},
  ));
  const campaignGroupID = useSelector(
    (state: any) => state.ucd.newlyCreatedCampaignGroup,
  );
  const createError = useSelector(
    (state: any) => state.ucd.createJourneyCampaignGroupError,
  );
  const previousRequest = useRef(createRequest);
  const isSubmitting = useRef(false);

  useEffect(() => {
    const wasPending = previousRequest.current.isPending;
    previousRequest.current = createRequest;

    if (!wasPending) {
      return;
    }

    if (createRequest.isSuccessful) {
      snackBar.success({ content: `Journey Campaign Group ${campaignGroupID} created successfully` });
      props.router.push(UCD_ROUTES_LINK.JOURNEY_CAMPAIGN_GROUP_VIEW(campaignGroupID));
    } else if (createRequest.isFailure) {
      isSubmitting.current = false;
      snackBar.error({ content: createError || 'Unable to create Journey Campaign Group' });
    }
  }, [campaignGroupID, createError, createRequest, props.router]);

  if (!enabled) {
    return <NotFoundPage {...props} namespace={RTC_NAMESPACE} />;
  }

  return (
    <UCDCreateJourneyCampaign
      onSubmit={(payload: CreateJourneyCampaignRequest) => {
        if (isSubmitting.current) {
          return;
        }

        isSubmitting.current = true;
        dispatch(createJourneyCampaignGroup(payload));
      }}
    />
  );
};

export default CreateJourneyCampaignGroup;
